import UserTypes from '../user/user.types';
import AnyAction from 'store/anyActions';
import AuthState from './auth.state';
import AppTypes from 'store/app/app.types';

const defaultState = { authenticated: false, logout: false };

export default function(state: AuthState = defaultState, action: AnyAction) {
    switch (action.type) {
        case UserTypes.USER_LOADED:
            return { ...state, logout: false };
        case UserTypes.USER_AUTHENTICATED:
            return { authenticated: true, ...action.payload };
        case UserTypes.USER_AUTH_ERROR:
            return {
                ...state,
                authenticating: false,
                authenticated: false,
                authError: action.payload.error,
            };
        case UserTypes.AUTHENTICATING_USER:
            return { ...state, authenticating: true };
        case UserTypes.VALIDATING_TOKEN:
            return {
                roles: state.roles,
                features: state.features,
                token: state.token,
                refreshToken: state.refreshToken,
                validatingToken: true,
                authenticated: state.authenticated,
            };
        case UserTypes.REQUESTING_TOKEN:
            return { requestingToken: true };
        case UserTypes.MFA_REQUIRED:
            return {
                mfa: action.payload
            }
        case UserTypes.TOKEN_REQUESTED:
            return { tokenRequested: true };
        // case UserTypes.INCORRECT_TOKEN:
        //     return { tokenRequested: true };
        case UserTypes.TOKEN_ERROR:
            return { tokenError: true };
        case UserTypes.LOGIN:
            return { ...state, logout: false, authError: '' };
        case UserTypes.LOGOUT:
        case AppTypes.CCP_LOGOUT:
            return { authenticated: false, logout: true, token: null };
        case UserTypes.NEW_PASSWORD_REQUIRED:
            return { newPasswordRequired: true };
        case UserTypes.FORGOT_PASSWORD:
            return { userForgotPassword: true };
        case UserTypes.REMEMBERED_PASSWORD:
            return { userForgotPassword: false };
        case UserTypes.FORGOT_PASSWORD_GET_CODE:
            return { userForgotPassword: true, userForgotPasswordGetCode: true };
        case UserTypes.FORGOT_PASSWORD_CONFIRM:
            return { ...defaultState };
        default:
            return state;
    }
}
